export default __webpack_public_path__ + "static/media/mtlogo.3841ae30.png";